import 'core-js/es';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd-mobile';
import { BrowserRouter } from 'react-router-dom';
import { getScript } from '@/common/utils/get-script';
import { getCss } from '@/common/utils/get-css';
import { AliveScope } from 'react-activation';
import store from '@/store/store';
import { Provider } from 'react-redux';
import App from './app';
import dayjs from 'dayjs';
import zhCN from 'antd-mobile/es/locales/zh-CN';
import 'dayjs/locale/zh-cn';
import 'amfe-flexible';
import './global.less';
import { aMapServiceHost } from './common/utils/amap';
import { initSentry } from 'src/common/utils/sentry';
import { makeUseOfTokenGetData } from './common/utils/ways';

dayjs.locale('zh-cn');
// https://github.com/CJY0208/react-activation/issues/173
// import { autoFixContext } from 'react-activation';

// autoFixContext(
//   [require('react/jsx-runtime'), 'jsx', 'jsxs', 'jsxDEV'],
//   [require('react/jsx-dev-runtime'), 'jsx', 'jsxs', 'jsxDEV']
// );

window.getScript = getScript;
window.getCss = getCss;
// https://lbs.amap.com/api/javascript-api-v2/guide/abc/load
window._AMapSecurityConfig = {
  serviceHost: aMapServiceHost,
};
initSentry();
// 大数据埋点
if (process.env.NODE_ENV !== 'development') {
  makeUseOfTokenGetData();
  window.LHBbigdata && window.LHBbigdata.init({
    isSpa: true,
    cha_type: 'Location',
    // 在cookie或者localstorage里抓取对应的参数放入到外层数据里
    extendOuterConfig: [
      // 要求不上报token，说不安全
      // {
      //   key: 'token',
      //   target: 'insightToken',
      // },
      // 根据抓取的目标参数命名不同，上报数据等同于上面
      {
        key: 'user_id',
        target: 'EMPLOYEE_ID'
      }, {
        key: 'tenant_id',
        target: 'TENANT_ID'
      }
      // {
      //   key: 'user_id',
      //   target: 'trace_id'
      // }
    ],
    si: 'h5',
    sendFunc: function(params, config) {
      try {
        window.LHBbigdata.xhrTool.send(process.env.BIGDATA_URL || (process.env.NODE_TYPE === 'pe' ? config.logPathPro : config.logPathPre), params);
      } catch (err) {}
    }
  });
}

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <AliveScope>
      <Provider store={store}>
        <ConfigProvider locale={zhCN}>
          <App />
        </ConfigProvider>
      </Provider>
    </AliveScope>
  </BrowserRouter>
);

